import { GenericService } from 'services/genericService';
import { Observable } from 'rxjs';
import { getQualtricsToken } from 'utils/api/queries/securityServices';

export class SecurityService extends GenericService {
	public static getQualtricsToken(): Observable<any> {
		return getQualtricsToken().call();
	}
}
